module.exports = __webpack_public_path__ + "585fb2f1789e40b12002a08b72386a0f.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-user/move-accounts/move-accounts.html
// module id = 2018
// module chunks = 0